import counter from "./counter";
import {
  safeAdd,
  safeDivide,
  safeMultiply,
  safePercentage,
  safeSubtract,
} from "./safeMath";
import toNegative from "./toNegative";

const MathUtils = {
  counter,
  safeAdd,
  safeSubtract,
  safeDivide,
  safeMultiply,
  safePercentage,
  toNegative,
};

export default MathUtils;
